module.exports = __webpack_public_path__ + "static/media/ictse.8727c2aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ictse.jpg
// module id = 5738
// module chunks = 0